import { connect } from 'react-redux'
import StopDescription from '../components/stopdescription/StopDescription'
import { currentStop, pointInfo, mediaListByType, selectedLanguage } from 'aria-viewer/utils/functions'
import { forceMediaPause } from 'aria-viewer/interactive-element/actions/common'
import { hideDrawer } from 'aria-viewer/drawer/drawerMenuActions'
import { setShareUrlId } from 'aria-viewer/contextmenu/contextMenuActions'
import { StopDescriptionModals } from 'aria-viewer/stopselector/components/stopdescription/constants'
import { MEDIA_MODULE_TYPES, MEDIA_TYPES } from 'aria-viewer/tour/constants'
import {
    setStopDescriptionOpen,
    setSupplementalMediaType,
    setStopDescrptionMedia,
    setStopDescriptionModal,
} from '../actions/stopDescriptionActions'

const getSupplementalMediaFromMediaList = mediaListByType => [
    ...mediaListByType[MEDIA_MODULE_TYPES.PANOS],
    ...mediaListByType[MEDIA_MODULE_TYPES.PHOTOS],
    ...mediaListByType[MEDIA_MODULE_TYPES.VIDEOS],
]

const mapStateToProps = state => ({
    title: currentStop(state).title,
    description: pointInfo(state).description,
    supplementalMedia: getSupplementalMediaFromMediaList(mediaListByType(state)),
    language: selectedLanguage(state).get('language'),
    containerSize: {
        width: state.getIn(['device', 'viewportWidth']),
        height: state.getIn(['device', 'viewportHeight']),
    },
    currentMedia: state.getIn(['stopDescription', 'media']),
    currentModal: state.getIn(['stopDescription', 'currentModal']),
})

const mapDispatchToProps = dispatch => ({
    onClose: () => {
        dispatch(forceMediaPause(false))
        dispatch(hideDrawer())
        dispatch(setStopDescriptionOpen(false))
        dispatch(setSupplementalMediaType(null))
    },

    onMediaClick: media => {
        dispatch(setStopDescrptionMedia(media))
        dispatch(setSupplementalMediaType(media.mediaType))
        switch (media.mediaType) {
            case MEDIA_TYPES.photo:
                dispatch(setShareUrlId(media.photoid))
                break
            default:
                dispatch(setShareUrlId(media.id))
                break
        }
        dispatch(setStopDescriptionModal(StopDescriptionModals.MEDIA_VIEW))
    },

    onModalClose: _ => {
        dispatch(setStopDescriptionModal(null))
        dispatch(setSupplementalMediaType(null))
        dispatch(setShareUrlId(null))
    },

    onReadMoreClick: _ => {
        dispatch(setStopDescriptionModal(StopDescriptionModals.MORE_DESCRIPTION))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(StopDescription)
